import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ErrorPage from './error-page'


export default class ErrorBoundary extends Component {
  // info: null
  state = { error: null }

  componentDidCatch(error) {
    // TODO: log to sentry, add info as state
    this.setState({ error })
  }

  render() {
    const { error } = this.state
    if (error) {
      return (
        <ErrorPage />
      )
    }

    return this.props.children
  }
}
ErrorBoundary.propTypes = { children: PropTypes.node.isRequired }

/**
 * Used for React Router's <Route> render function.
 *
 * <Route render={renderErrorBoundedRoute(ComponentUsesRouteProps)}
 *
 * @param {React.Component} Component
 */
export const renderErrorBoundedRoute = (Component) => (routeProps) => (
  <ErrorBoundary key={Component.name}>
    <Component {...routeProps} />
  </ErrorBoundary>
)
